export default "__VITE_ASSET__C6wQ9SJB__"